import { render, staticRenderFns } from "./productPanel.vue?vue&type=template&id=36ed0a23&scoped=true&"
import script from "./productPanel.vue?vue&type=script&lang=js&"
export * from "./productPanel.vue?vue&type=script&lang=js&"
import style0 from "./productPanel.vue?vue&type=style&index=0&id=36ed0a23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed0a23",
  null
  
)

/* custom blocks */
import block0 from "./productPanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports